module.exports = __webpack_public_path__ + "img/mergejil.fc5810f6.svg";